module.exports = __webpack_public_path__ + "img/1 (104).3d7a0bab.png";